import React from 'react';
import ReactDOM from 'react-dom';
import { IntlProvider } from 'react-intl';
import { Provider, useSelector } from 'react-redux';
import cx from 'classnames';

import store from './store';
import { getIsBigTabletAndDesktop, getIsEmex, getIsMobile } from './store/selectors';

import initErrorLogging from './api/errorLogging';
import Header from './components/Header';
import Layout from './components/Layout';
import MobileHeader from './components/MobileHeader';
import ChatWindowContainer from './containers/ChatWindowContainer';
import SubscriptionsContainer from './containers/SubscriptionsContainer';

import s from './index.module.css';
import w from './widget.module.css';
import { ScriptYM } from './components/ScriptYM';

initErrorLogging();

const App = () => {
  const isMobileLayout = useSelector(getIsMobile);
  const isEmex = useSelector(getIsEmex);
  const isBigTabletAndDesktop = useSelector(getIsBigTabletAndDesktop);
  const pathname = window.location.pathname;
  const isWidgetPath = pathname.includes('/widget');

  return (
    <div className={cx(s.app, { [w.widgetApp]: isWidgetPath })}>
      {isMobileLayout && <MobileHeader isEmex={isEmex}/>}
      {isBigTabletAndDesktop && <Header />}
      <ScriptYM />
      <SubscriptionsContainer>
        <Layout isWidgetPath={isWidgetPath}>
          <ChatWindowContainer isWidgetPath={isWidgetPath} />
        </Layout>
      </SubscriptionsContainer>
    </div>
  );
};

ReactDOM.render(
  <Provider store={store}>
    <IntlProvider locale="ru" defaultLocale="ru">
      <App />
    </IntlProvider>
  </Provider>,
  document.getElementById('root'),
);
